import React, { useEffect, useRef, useState } from 'react';

import { drawPlinko, fallBall } from '../assets/js/plinko.js';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../app/store';
import AuthService from "../services/auth.service";
import { useNavigate } from 'react-router-dom';
import { showToast } from '../app/slice/toastsSlice';
import Loader from '../components/loader';
import { fetchWallet } from '../app/slice/walletSlice';

type HistoryItem = {
  id: number;
  value: string;
};

type risk = 'low' | 'medium' | 'high';

const PlinkoGame: React.FC = () => {
  const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
  const [isPageloading, setIsPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<number>(8);
  const [riskLevel, setRiskLevel] = useState<risk>("low");
  const [isAutoCall, setIsAutoCall] = useState<boolean>(false);
  const [betType, setBetType] = useState<any>('manual');
  const [betAmount, setBetAmount] = useState<number | any>("0");
  const [wallet, setWallet] = useState<any | Number>(walletAmount);
  const [isGameActive, setIsGameActive] = useState(false);
  const [history, setHistory] = useState<HistoryItem[]>([]);
  const [animatedIds, setAnimatedIds] = useState<Set<number>>(new Set());
  const isStopped = useRef<boolean>(false);
  const autoDroppingInterval = useRef<NodeJS.Timeout | null>(null);
  const [noOfBet, setNoOfBet] = useState<number | any>(0);
  const [multiplierSets, setMultiplierSets] = useState();
  const [message, setMessage] = useState("");
  const [gameData, setGameData] = useState<any>({});
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const multiplierSets1 = {
    8: [50, 20, 7, 4, 3, 1, 0, 0, 0],
    9: [50, 20, 10, 7, 4, 3, 1, 0, 0, 0],
    10: [50, 20, 10, 7, 4, 3, 1, 0, 0, 0, 0],
    11: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 0],
    12: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 1, 1],
    13: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 1, 1, 3],
    14: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 1, 1, 3, 0],
    15: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 1, 1, 3, 4, 7],
    16: [50, 20, 10, 7, 4, 3, 1, 1, 0, 0, 0, 1, 1, 3, 4, 7, 50],
  };

  useEffect(() => {
    AuthService.plinkoMultipliers()
      .then(
        (response) => {
          // console.log(response?.data?.plinko_multipliers); 
          if (response.status === 200) {
            setMultiplierSets(response?.data?.plinko_multipliers)

            // 
            return
          } else {
            setMessage(response?.message);
            let toast = {
              type: 'error',
              title: 'Error',
              message: response?.message
            }
            dispatch(showToast(toast));
            setIsPageLoading(false);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
          setIsPageLoading(false);
        }
      }).finally(() => {
        setIsPageLoading(false);
      });
  }, []);

  useEffect(() => {   
    if (multiplierSets) {
      let multiplier = multiplierSets[selectedRows as keyof typeof multiplierSets];     
      drawPlinko(selectedRows, multiplier[riskLevel as keyof typeof multiplier]); //


    }
  }, [selectedRows, riskLevel, multiplierSets]);


  useEffect(() => {
    setWallet(walletAmount);
  }, [walletAmount]);


  function handleClickBetType(type: any) {
    setBetType(type);
  };


  function handlePlaceBet() {
    let formData = {
      rows: selectedRows,
      risk: riskLevel,
      amount: betAmount
    }

    AuthService.PlaceBetPlinko(formData)
      .then(
        (response) => {
          // console.log(response.data);
          if (response.status === 200) {
            dispatch(fetchWallet());
            setGameData(response.data);
            fallBall();
          } else {
            if (response.status !== 204) {
              setMessage(response?.message);
              let toast = {
                type: 'error',
                title: 'Error',
                message: response?.message
              }
              dispatch(showToast(toast));
            }

            setLoading(false);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
          setLoading(false);
        }
      }).finally(() => {
        setLoading(false);
      });


  }

  const startAutoBet = () => {
    if (!isAutoCall) {
      setIsAutoCall(true);
    }
  };


  function stopAutoBet() {
    if (autoDroppingInterval.current) {
      clearInterval(autoDroppingInterval.current);
      autoDroppingInterval.current = null;
      setIsAutoCall(false);
    }


  }

  useEffect(() => {
    if (isAutoCall && !autoDroppingInterval.current) {
      autoDroppingInterval.current = setInterval(() => {
        setNoOfBet((prevCount: any) => {
          if (prevCount === 0) return 0;

          if (prevCount <= 1) {
            if (autoDroppingInterval.current) {
              clearInterval(autoDroppingInterval.current);
              autoDroppingInterval.current = null;
              setIsAutoCall(false);
            }
            return 0;
          }
          return prevCount - 1;
        });

        fallBall();

      }, 1000);
    }

    return () => {
      if (autoDroppingInterval.current) {
        clearInterval(autoDroppingInterval.current);
        autoDroppingInterval.current = null;
      }
    };
  }, [isAutoCall]);


  const handleNoBetChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setNoOfBet(inputValue);
    }

  };


  useEffect(() => {
    let counter = 0;
    const interval = setInterval(() => {
      const newValue = `${Math.floor(Math.random() * 100)}x`;
      const newId = Date.now() + Math.random(); // Ensure uniqueness

      setHistory((prev) => {
        const updated = [{ id: newId, value: newValue }, ...prev];
        return updated.slice(0, 100);
      });

      setAnimatedIds((prev) => new Set(prev).add(newId));
      counter++;

      if (counter >= 100) clearInterval(interval);
    }, 1500);

    return () => clearInterval(interval);
  }, []);


  const onChangeAmount = (e: any) => {
    if (!isNaN(e.target.value)) {
      setBetAmount(e.target.value);
    }
  };

  const handleAmountAdd = (event: any, amt: number) => {
    event.preventDefault();
    if (amt > wallet?.user_combined_wallet) {
      setBetAmount(wallet?.user_combined_wallet);
      return;
    }
    setBetAmount(Number(amt).toFixed(2));
  };


  return (
    <div className='container webMine plinkoGame'>
      {isPageloading && <Loader />}
      <div className="row aviagameBagk px-0 pt-0">
        <div className='plinkoGamepp p-0 pt-0'>
          <div className="canvas-container">
            <canvas id="canvas" style={{ background: 'none' }}></canvas>

            <ul className="plinkohist">
              {history.map((item: any) => (
                <li
                  key={item.id}
                  className={`history-item ${animatedIds.has(item.id) ? '' : ''
                    }`}
                  onAnimationEnd={() => {
                    setAnimatedIds((prev) => {
                      const updated = new Set(prev);
                      updated.delete(item.id);
                      return updated;
                    });
                  }}
                >
                  {item.value}
                </li>
              ))}
            </ul>
          </div>
          <div className="notes">
            <div className="note" id="note-0"></div>
            <div className="note" id="note-1"></div>
            <div className="note" id="note-2"></div>
            <div className="note" id="note-3"></div>
            <div className="note" id="note-4"></div>
            <div className="note" id="note-5"></div>
            <div className="note" id="note-6"></div>
            <div className="note" id="note-7"></div>
            <div className="note" id="note-8"></div>
            <div className="note" id="note-9"></div>
            <div className="note" id="note-10"></div>
            <div className="note" id="note-11"></div>
            <div className="note" id="note-12"></div>
            <div className="note" id="note-13"></div>
            <div className="note" id="note-14"></div>
            <div className="note" id="note-15"></div>
            <div className="note" id="note-16"></div>
          </div>
        </div>
      </div>
      <div className='row bg-dark-Bet'>
        <div className="tab-content" id="pills-tabContent">
          <div className="col-12 betSelection mb-my webMineTab">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
              </li>
            </ul>
          </div>
          <div className="tab-pane fade show active" id="pills-ManualBet" role="tabpanel" aria-labelledby="pills-ManualBet-tab">
            <div className="row">
              <div className="col-12 mb-my mt-2">
                <label htmlFor='amount'>Amount</label>
                <div className='amountInpunt'>
                  <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                    <p>₹</p>
                    <input type="text" id="amount" placeholder="enter amount" value={betAmount} onChange={(e) => onChangeAmount(e)} maxLength={10} autoComplete="off" readOnly={loading || isGameActive || isAutoCall} />
                  </div>
                  <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', width: '100%' }}>
                    <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount / 2) : undefined} disabled={loading || isGameActive || isAutoCall}>1/2</button>
                    <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount * 2) : undefined} disabled={loading || isGameActive || isAutoCall}>2x</button>
                    <button onClick={!isGameActive ? event => handleAmountAdd(event, wallet?.user_combined_wallet) : undefined} disabled={loading || isGameActive || isAutoCall}>All In</button>

                  </div>
                </div>
              </div>
              <div className="col-6 mb-my">
                <label htmlFor='risk-level'>Risk</label>
                <div className="custom-select">
                  <select id="risk-level" aria-label="Default select example" defaultValue={riskLevel} onChange={(e) => (setRiskLevel((e.target.value as risk)))}>
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </select>
                </div>
              </div>
              <div className="col-6 mb-my">
                <label htmlFor='rows'>Row</label>
                <div className="custom-select">
                  <select id="rows" aria-label="Row selection" defaultValue={selectedRows} onChange={(e) => (setSelectedRows(Number(e.target.value)))}>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                  </select>
                </div>
              </div>

              {betType === 'auto' ?
                <>
                  <div className="col-12 mb-my">
                    <label>No. of Bets</label>
                    <div className='amountInpunt'>
                      <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                        <input type="number" id="no_of_bet" value={noOfBet} onChange={handleNoBetChange} autoComplete='off' min={0} readOnly={isAutoCall} />
                      </div>
                      <div className='d-flex align-items-center justify-content-end' style={{ height: '100%' }}>
                        <button style={{ background: 'none' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M3 12C3 10.067 4.567 8.5 6.5 8.5C7.7035 8.5 8.51959 8.9338 9.19914 9.61336C9.9255 10.3397 10.4851 11.3322 11.1258 12.4856L11.1595 12.5462C11.7605 13.6283 12.4431 14.8573 13.3866 15.8009C14.3946 16.8088 15.7035 17.5 17.5 17.5C20.5376 17.5 23 15.0376 23 12C23 8.96243 20.5376 6.5 17.5 6.5C15.8394 6.5 14.3508 7.2359 13.3423 8.39937C13.7887 9.05406 14.1574 9.70577 14.464 10.2574C15.0681 9.20718 16.2014 8.5 17.5 8.5C19.433 8.5 21 10.067 21 12C21 13.933 19.433 15.5 17.5 15.5C16.2965 15.5 15.4804 15.0662 14.8009 14.3866C14.0745 13.6603 13.5149 12.6678 12.8742 11.5144L12.8405 11.4538C12.2395 10.3717 11.5569 9.14265 10.6134 8.19914C9.60541 7.1912 8.2965 6.5 6.5 6.5C3.46243 6.5 1 8.96243 1 12C1 15.0376 3.46243 17.5 6.5 17.5C8.16056 17.5 9.64923 16.7641 10.6577 15.6006C10.2113 14.9459 9.84262 14.2942 9.53605 13.7426C8.93194 14.7928 7.79856 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12Z" fill="white" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 mb-my mt-2">
                    {isAutoCall ?

                      <button className='betBtn' onClick={!loading ? () => stopAutoBet() : undefined} disabled={loading}>
                        {loading ?
                          <>
                            Please wait...
                          </>
                          :
                          <>
                            Stop Auto Bet
                          </>
                        }
                      </button>

                      :
                      <button className='betBtn' onClick={!loading ? () => startAutoBet() : undefined} disabled={betAmount === '' || loading ? true : false}>
                        {loading ?
                          <>
                            Please wait...
                          </>
                          :
                          <>
                            Start Auto Bet
                          </>
                        }
                      </button>
                    }
                  </div>
                </>
                :

                !isGameActive &&
                <div className="col-12 mb-my mt-2">
                  <button className='betBtn' onClick={!loading ? handlePlaceBet : undefined} disabled={loading || betAmount === '' ? true : false}>
                    {loading ?
                      <>
                        Please wait...
                      </>
                      :
                      <>
                        Bet
                      </>
                    }
                  </button>
                </div>
              }

            </div>
          </div>

          <div className="col-12 betSelection mb-my">
            <ul className="nav nav-pills" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlinkoGame;